import { motion } from "framer-motion";
import { Shield, Anchor } from "lucide-react";
import SceneShell from "../components/SceneShell";
import CastleGraphic from "../components/CastleGraphic";

/**
 * Scene 52 — The Moat = Social Week (retention + protection).
 * Castle + warriors remain; the moat shimmers in around the base.
 *
 * Now in the SOCIAL WEEK gold/yellow palette to match the brand wordmark.
 */

const GOLD = "#e9a820";

export default function Scene52_TheMoat() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-the-moat">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 50% 70%, rgba(233,168,32,0.18) 0%, transparent 60%)",
            "radial-gradient(ellipse at 50% 70%, rgba(233,168,32,0.32) 0%, transparent 60%)",
            "radial-gradient(ellipse at 50% 70%, rgba(233,168,32,0.18) 0%, transparent 60%)",
          ],
        }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative w-full h-full flex flex-col">
        <div className="flex-1 mt-2 mx-auto w-full max-w-[1400px] relative">
          <CastleGraphic layer={3} moatTone="gold" />

          {/* Centred glowing callout above the castle */}
          <motion.div
            initial={{ opacity: 0, y: -18, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 1.0, delay: 1.0, ease: [0.16, 1, 0.3, 1] }}
            className="absolute top-2 sm:top-4 left-1/2 -translate-x-1/2 z-10"
            data-testid="moat-callout"
          >
            <div
              className="rounded-2xl px-7 py-4 flex items-center gap-4"
              style={{
                background: "rgba(233,168,32,0.10)",
                border: `1px solid ${GOLD}88`,
                boxShadow: `0 0 80px ${GOLD}55`,
              }}
            >
              <Shield className="w-5 h-5" style={{ color: GOLD }} />
              <div>
                <div
                  className="text-[10px] tracking-[0.32em] uppercase mb-1"
                  style={{ color: GOLD }}
                >
                  The Moat
                </div>
                <div
                  className="kn-display text-xl sm:text-2xl"
                  style={{ color: "#e2e8f0", fontWeight: 700 }}
                >
                  Social{" "}
                  <span
                    style={{
                      background:
                        "linear-gradient(135deg, #d4940a 0%, #e9a820 50%, #d4940a 100%)",
                      WebkitBackgroundClip: "text",
                      backgroundClip: "text",
                      color: "transparent",
                    }}
                  >
                    Week
                  </span>
                </div>
              </div>
              <div className="hidden sm:flex flex-col gap-1 pl-4 border-l border-white/15">
                <div className="flex items-center gap-2 text-xs">
                  <Anchor className="w-3 h-3" style={{ color: GOLD }} />
                  <span style={{ color: "rgba(255,255,255,0.85)" }}>Retention</span>
                </div>
                <div className="flex items-center gap-2 text-xs">
                  <Shield className="w-3 h-3" style={{ color: GOLD }} />
                  <span style={{ color: "rgba(255,255,255,0.85)" }}>Protection</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </SceneShell>
  );
}
